import _ from 'lodash';

export const bindSurrogateId = (id: string, elements: HTMLElement | HTMLCollection, isPropagate = true) => {
    
    if (elements instanceof HTMLCollection) {
        _.each(elements, (element: HTMLElement) => {
            replaceSurrogateId(id, element, isPropagate);
        });
    } else {
        replaceSurrogateId(id, <HTMLElement>elements, isPropagate);
    }
};

export const getSurrogateId = (element: HTMLElement): string => {
  
    return _.find(element.getAttributeNames(), (attr) => /(_ngcontent)/g.test(attr));
};

const replaceSurrogateId = (id: string, element: HTMLElement, isPropagate) => {
    element.removeAttribute(id);
    
    element.setAttribute(id, '');
    
    if (element.children && isPropagate) {
        bindSurrogateId(id, element.children, isPropagate);
    }
};
